import {
    CredentialUsageType,
    type CredentialUsageListItem,
    type CredentialUsageReference,
} from '@anchorbase/pillar-sdk';

export const buildCredentialUsageSelectionKey = (
    usage: CredentialUsageReference | CredentialUsageListItem
): string => {
    if (usage.usage_type === CredentialUsageType.LOGICAL_TERMINAL) {
        return `${usage.usage_type}:${usage.logical_terminal_uuid}`;
    }
    return `${usage.usage_type}:${usage.terminal_device_uuid}`;
};

export const toCredentialUsageReference = (
    usage: CredentialUsageReference | CredentialUsageListItem
): CredentialUsageReference => {
    if (usage.usage_type === CredentialUsageType.LOGICAL_TERMINAL) {
        return {
            usage_type: usage.usage_type,
            logical_terminal_uuid: usage.logical_terminal_uuid,
        };
    }
    return {
        usage_type: usage.usage_type,
        terminal_device_uuid: usage.terminal_device_uuid,
    };
};
